<script setup lang="ts">
import { usePage } from '@inertiajs/vue3';
import { watch } from 'vue';
import AppShell from '@/components/AppShell.vue';
import AppSidebar from '@/components/AppSidebar.vue';
import { SidebarInset } from '@/components/ui/sidebar';
import { Toaster } from '@/components/ui/sonner';
import { useToast } from '@/composables/useToast';
import { useUserChannel } from '@/composables/useUserChannel';
import 'vue-sonner/style.css';

const { notifications } = useUserChannel();
const toast = useToast();
const page = usePage();

watch(
    () => page.props.flash,
    (flash: any) => {
        if (typeof window === 'undefined' || !flash) {
            return;
        }

        if (flash.success) {
            toast.success(flash.success);
        }

        if (flash.error) {
            toast.error(flash.error);
        }

        if (flash.warning) {
            toast.warning(flash.warning);
        }

        if (flash.info) {
            toast.info(flash.info);
        }
    },
    { deep: true, immediate: true },
);
</script>

<template>
    <AppShell variant="sidebar">
        <AppSidebar :notifications="notifications" />
        <SidebarInset class="flex min-h-0 flex-col overflow-hidden">
            <slot />
        </SidebarInset>
    </AppShell>
    <Toaster />
</template>
